import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { DeliveryPlan } from 'services/action';

import { Page, Button } from 'ui/components';

import { FormInput, FormItems } from './component/form';

const initialState = {
  data: null,
  form: null,
  items: [],
};

const UpdateScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const [{ form, items, data }, setState] = React.useState(initialState);

  const $onLoad = async (id) => {
    const req = await Dispatch(DeliveryPlan.$show(id));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: req?.data }));
    }
  };

  const $handleFormChange = (v) => {
    setState((prevState) => ({ ...prevState, form: v }));
  };

  const $handleItemsChange = (v) => {
    setState((prevState) => ({ ...prevState, items: v }));
  };

  const $handleSubmit = async () => {
    const payload = {
      customer_id: form?.customer?.id,
      shipping_at: form?.shipping_at?.formatted,
      ref_code: form?.ref_code,
      recipient_id: form?.recipient?.id,
      recipient_name: form?.recipient?.name,
      recipient_phone: form?.recipient?.phone,
      recipient_address: form?.recipient?.address,
      recipient_region_id: form?.recipient?.region?.village_id,
      note: form?.note,
      ...items,
    };

    const submit = await Dispatch(DeliveryPlan.$update(data?.id, payload));

    if (submit?.message === 'success') {
      History.replace(`/delivery/plan/${submit?.data?.id}`);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page type="form" className=" bg-white" onSubmit={$handleSubmit}>
      <Page.Header title="Perbaharui Rencana Pengiriman" />

      <Page.Body className="d-block px-3">
        <div className="row">
          <div className="col-md-6 ">
            <FormInput data={data} onInputChange={$handleFormChange} />
          </div>
          <div className="col-md-6 px-3 px-md-3 pe-md-3">
            <FormItems data={data} onInputChange={$handleItemsChange}
            />
          </div>
        </div>
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/delivery/plan`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;
